import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import './media/workspaceTrustEditor.css.js';
import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { Disposable, MutableDisposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { localizeWithPath, localize2WithPath } from 'vscode/vscode/vs/nls';
import { registerAction2, Action2 } from 'vscode/vscode/vs/platform/actions/common/actions';
import { Extensions as Extensions$1 } from 'vscode/vscode/vs/platform/configuration/common/configurationRegistry';
import { IDialogService } from 'vscode/vscode/vs/platform/dialogs/common/dialogs.service';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import 'vscode/vscode/vs/platform/notification/common/notification';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { IWorkspaceTrustEnablementService, IWorkspaceTrustManagementService, IWorkspaceTrustRequestService } from 'vscode/vscode/vs/platform/workspace/common/workspaceTrust.service';
import { Extensions, registerWorkbenchContribution2 } from 'vscode/vscode/vs/workbench/common/contributions';
import { Codicon } from 'vscode/vscode/vs/base/common/codicons';
import { IEditorService } from 'vscode/vscode/vs/workbench/services/editor/common/editorService.service';
import { ContextKeyExpr } from 'vscode/vscode/vs/platform/contextkey/common/contextkey';
import { IContextKeyService } from 'vscode/vscode/vs/platform/contextkey/common/contextkey.service';
import { ICommandService } from 'vscode/vscode/vs/platform/commands/common/commands.service';
import { IStatusbarService } from 'vscode/vscode/vs/workbench/services/statusbar/browser/statusbar.service';
import { EditorPaneDescriptor } from 'vscode/vscode/vs/workbench/browser/editor';
import { shieldIcon, WorkspaceTrustEditor } from './workspaceTrustEditor.js';
import { WorkspaceTrustEditorInput } from '../../../services/workspaces/browser/workspaceTrustEditorInput.js';
import { WORKSPACE_TRUST_STARTUP_PROMPT, WORKSPACE_TRUST_BANNER, WORKSPACE_TRUST_ENABLED, WORKSPACE_TRUST_UNTRUSTED_FILES, WORKSPACE_TRUST_EMPTY_WINDOW } from 'vscode/vscode/vs/workbench/services/workspaces/common/workspaceTrust';
import { EditorExtensions } from 'vscode/vscode/vs/workbench/common/editor';
import { ITelemetryService } from 'vscode/vscode/vs/platform/telemetry/common/telemetry.service';
import { isSingleFolderWorkspaceIdentifier, toWorkspaceIdentifier, isEmptyWorkspaceIdentifier } from 'vscode/vscode/vs/platform/workspace/common/workspace';
import { IWorkspaceContextService } from 'vscode/vscode/vs/platform/workspace/common/workspace.service';
import { resolve, dirname as dirname$1 } from 'vscode/vscode/vs/base/common/path';
import { IConfigurationService } from 'vscode/vscode/vs/platform/configuration/common/configuration.service';
import { MarkdownString } from 'vscode/vscode/vs/base/common/htmlContent';
import { IStorageService } from 'vscode/vscode/vs/platform/storage/common/storage.service';
import { IHostService } from 'vscode/vscode/vs/workbench/services/host/browser/host.service';
import { IBannerService } from 'vscode/vscode/vs/workbench/services/banner/browser/bannerService.service';
import { isVirtualWorkspace } from 'vscode/vscode/vs/platform/workspace/common/virtualWorkspace';
import { LIST_WORKSPACE_UNSUPPORTED_EXTENSIONS_COMMAND_ID } from 'vscode/vscode/vs/workbench/contrib/extensions/common/extensions';
import { IWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/common/environmentService.service';
import { WORKSPACE_TRUST_SETTING_TAG } from 'vscode/vscode/vs/workbench/contrib/preferences/common/preferences';
import { IPreferencesService } from 'vscode/vscode/vs/workbench/services/preferences/common/preferences.service';
import { ILabelService } from 'vscode/vscode/vs/platform/label/common/label.service';
import { IProductService } from 'vscode/vscode/vs/platform/product/common/productService.service';
import { WorkspaceTrustContext, MANAGE_TRUST_COMMAND_ID } from 'vscode/vscode/vs/workbench/contrib/workspace/common/workspace';
import { isWeb } from 'vscode/vscode/vs/base/common/platform';
import { IRemoteAgentService } from 'vscode/vscode/vs/workbench/services/remote/common/remoteAgentService.service';
import { securityConfigurationNodeBase } from 'vscode/vscode/vs/workbench/common/configuration';
import { basename, dirname } from 'vscode/vscode/vs/base/common/resources';
import { URI } from 'vscode/vscode/vs/base/common/uri';
import { IEnvironmentService } from 'vscode/vscode/vs/platform/environment/common/environment.service';
import { IFileService } from 'vscode/vscode/vs/platform/files/common/files.service';
import Severity$1 from 'vscode/vscode/vs/base/common/severity';

const _moduleId = "vs/workbench/contrib/workspace/browser/workspace.contribution";
const BANNER_RESTRICTED_MODE = 'workbench.banner.restrictedMode';
const STARTUP_PROMPT_SHOWN_KEY = 'workspace.trust.startupPrompt.shown';
const BANNER_RESTRICTED_MODE_DISMISSED_KEY = 'workbench.banner.restrictedMode.dismissed';
let WorkspaceTrustContextKeys = class WorkspaceTrustContextKeys extends Disposable {
    constructor(contextKeyService, workspaceTrustEnablementService, workspaceTrustManagementService) {
        super();
        this._ctxWorkspaceTrustEnabled = WorkspaceTrustContext.IsEnabled.bindTo(contextKeyService);
        this._ctxWorkspaceTrustEnabled.set(workspaceTrustEnablementService.isWorkspaceTrustEnabled());
        this._ctxWorkspaceTrustState = WorkspaceTrustContext.IsTrusted.bindTo(contextKeyService);
        this._ctxWorkspaceTrustState.set(workspaceTrustManagementService.isWorkspaceTrusted());
        this._register(workspaceTrustManagementService.onDidChangeTrust(trusted => this._ctxWorkspaceTrustState.set(trusted)));
    }
};
WorkspaceTrustContextKeys = ( (__decorate([
    ( (__param(0, IContextKeyService))),
    ( (__param(1, IWorkspaceTrustEnablementService))),
    ( (__param(2, IWorkspaceTrustManagementService)))
], WorkspaceTrustContextKeys)));
( (Registry.as(Extensions.Workbench))).registerWorkbenchContribution(WorkspaceTrustContextKeys, 3 );
let WorkspaceTrustRequestHandler = class WorkspaceTrustRequestHandler extends Disposable {
    static { this.ID = 'workbench.contrib.workspaceTrustRequestHandler'; }
    constructor(dialogService, commandService, workspaceContextService, workspaceTrustManagementService, workspaceTrustRequestService) {
        super();
        this.dialogService = dialogService;
        this.commandService = commandService;
        this.workspaceContextService = workspaceContextService;
        this.workspaceTrustManagementService = workspaceTrustManagementService;
        this.workspaceTrustRequestService = workspaceTrustRequestService;
        this.registerListeners();
    }
    get useWorkspaceLanguage() {
        return !isSingleFolderWorkspaceIdentifier(toWorkspaceIdentifier(this.workspaceContextService.getWorkspace()));
    }
    registerListeners() {
        this._register(this.workspaceTrustRequestService.onDidInitiateOpenFilesTrustRequest(async () => {
            await this.workspaceTrustManagementService.workspaceResolved;
            const markdownDetails = [
                this.workspaceContextService.getWorkbenchState() !== 1  ?
                    ( localizeWithPath(
                        _moduleId,
                        0,
                        "You are trying to open untrusted files in a workspace which is trusted."
                    )) :
                    ( localizeWithPath(
                        _moduleId,
                        1,
                        "You are trying to open untrusted files in a window which is trusted."
                    )),
                ( localizeWithPath(
                    _moduleId,
                    2,
                    "If you don't want to open untrusted files, we recommend to open them in Restricted Mode in a new window as the files may be malicious. See [our docs](https://aka.ms/vscode-workspace-trust) to learn more."
                ))
            ];
            await this.dialogService.prompt({
                type: Severity$1.Info,
                message: this.workspaceContextService.getWorkbenchState() !== 1  ?
                    ( localizeWithPath(_moduleId, 3, "Do you want to allow untrusted files in this workspace?")) :
                    ( localizeWithPath(_moduleId, 4, "Do you want to allow untrusted files in this window?")),
                buttons: [
                    {
                        label: ( localizeWithPath(_moduleId, 5, "&&Open")),
                        run: ({ checkboxChecked }) => this.workspaceTrustRequestService.completeOpenFilesTrustRequest(1 , !!checkboxChecked)
                    },
                    {
                        label: ( localizeWithPath(_moduleId, 6, "Open in &&Restricted Mode")),
                        run: ({ checkboxChecked }) => this.workspaceTrustRequestService.completeOpenFilesTrustRequest(2 , !!checkboxChecked)
                    }
                ],
                cancelButton: {
                    run: () => this.workspaceTrustRequestService.completeOpenFilesTrustRequest(3 )
                },
                checkbox: {
                    label: ( localizeWithPath(_moduleId, 7, "Remember my decision for all workspaces")),
                    checked: false
                },
                custom: {
                    icon: Codicon.shield,
                    markdownDetails: ( (markdownDetails.map(md => { return { markdown: ( (new MarkdownString(md))) }; })))
                }
            });
        }));
        this._register(this.workspaceTrustRequestService.onDidInitiateWorkspaceTrustRequest(async (requestOptions) => {
            await this.workspaceTrustManagementService.workspaceResolved;
            const message = this.useWorkspaceLanguage ?
                ( localizeWithPath(_moduleId, 8, "Do you trust the authors of the files in this workspace?")) :
                ( localizeWithPath(_moduleId, 9, "Do you trust the authors of the files in this folder?"));
            const defaultDetails = ( localizeWithPath(
                _moduleId,
                10,
                "A feature you are trying to use may be a security risk if you do not trust the source of the files or folders you currently have open."
            ));
            const details = requestOptions?.message ?? defaultDetails;
            const buttons = requestOptions?.buttons ?? [
                { label: this.useWorkspaceLanguage ? ( localizeWithPath(_moduleId, 11, "&&Trust Workspace & Continue")) : ( localizeWithPath(_moduleId, 12, "&&Trust Folder & Continue")), type: 'ContinueWithTrust' },
                { label: ( localizeWithPath(_moduleId, 13, "&&Manage")), type: 'Manage' }
            ];
            if (!( (buttons.some(b => b.type === 'Cancel')))) {
                buttons.push({ label: ( localizeWithPath(_moduleId, 14, "Cancel")), type: 'Cancel' });
            }
            const { result } = await this.dialogService.prompt({
                type: Severity$1.Info,
                message,
                custom: {
                    icon: Codicon.shield,
                    markdownDetails: [
                        { markdown: ( (new MarkdownString(details))) },
                        { markdown: ( (new MarkdownString(( localizeWithPath(
                            _moduleId,
                            15,
                            "If you don't trust the authors of these files, we do not recommend continuing as the files may be malicious. See [our docs](https://aka.ms/vscode-workspace-trust) to learn more."
                        ))))) }
                    ]
                },
                buttons: ( (buttons.filter(b => b.type !== 'Cancel').map(button => {
                    return {
                        label: button.label,
                        run: () => button.type
                    };
                }))),
                cancelButton: (() => {
                    const cancelButton = buttons.find(b => b.type === 'Cancel');
                    if (!cancelButton) {
                        return undefined;
                    }
                    return {
                        label: cancelButton.label,
                        run: () => cancelButton.type
                    };
                })()
            });
            switch (result) {
                case 'ContinueWithTrust':
                    await this.workspaceTrustRequestService.completeWorkspaceTrustRequest(true);
                    break;
                case 'ContinueWithoutTrust':
                    await this.workspaceTrustRequestService.completeWorkspaceTrustRequest(undefined);
                    break;
                case 'Manage':
                    this.workspaceTrustRequestService.cancelWorkspaceTrustRequest();
                    await this.commandService.executeCommand(MANAGE_TRUST_COMMAND_ID);
                    break;
                case 'Cancel':
                    this.workspaceTrustRequestService.cancelWorkspaceTrustRequest();
                    break;
            }
        }));
    }
};
WorkspaceTrustRequestHandler = ( (__decorate([
    ( (__param(0, IDialogService))),
    ( (__param(1, ICommandService))),
    ( (__param(2, IWorkspaceContextService))),
    ( (__param(3, IWorkspaceTrustManagementService))),
    ( (__param(4, IWorkspaceTrustRequestService)))
], WorkspaceTrustRequestHandler)));
let WorkspaceTrustUXHandler = class WorkspaceTrustUXHandler extends Disposable {
    constructor(dialogService, workspaceContextService, workspaceTrustEnablementService, workspaceTrustManagementService, configurationService, statusbarService, storageService, workspaceTrustRequestService, bannerService, labelService, hostService, productService, remoteAgentService, environmentService, fileService) {
        super();
        this.dialogService = dialogService;
        this.workspaceContextService = workspaceContextService;
        this.workspaceTrustEnablementService = workspaceTrustEnablementService;
        this.workspaceTrustManagementService = workspaceTrustManagementService;
        this.configurationService = configurationService;
        this.statusbarService = statusbarService;
        this.storageService = storageService;
        this.workspaceTrustRequestService = workspaceTrustRequestService;
        this.bannerService = bannerService;
        this.labelService = labelService;
        this.hostService = hostService;
        this.productService = productService;
        this.remoteAgentService = remoteAgentService;
        this.environmentService = environmentService;
        this.fileService = fileService;
        this.entryId = `status.workspaceTrust`;
        this.statusbarEntryAccessor = this._register(( (new MutableDisposable())));
        (async () => {
            await this.workspaceTrustManagementService.workspaceTrustInitialized;
            if (this.workspaceTrustEnablementService.isWorkspaceTrustEnabled()) {
                this.registerListeners();
                this.updateStatusbarEntry(this.workspaceTrustManagementService.isWorkspaceTrusted());
                if (this.hostService.hasFocus) {
                    this.showModalOnStart();
                }
                else {
                    const focusDisposable = this.hostService.onDidChangeFocus(focused => {
                        if (focused) {
                            focusDisposable.dispose();
                            this.showModalOnStart();
                        }
                    });
                }
            }
        })();
    }
    registerListeners() {
        this._register(this.workspaceContextService.onWillChangeWorkspaceFolders(e => {
            if (e.fromCache) {
                return;
            }
            if (!this.workspaceTrustEnablementService.isWorkspaceTrustEnabled()) {
                return;
            }
            const addWorkspaceFolder = async (e) => {
                const trusted = this.workspaceTrustManagementService.isWorkspaceTrusted();
                if (trusted && (e.changes.added.length || e.changes.changed.length)) {
                    const addedFoldersTrustInfo = await Promise.all(( (e.changes.added.map(folder => this.workspaceTrustManagementService.getUriTrustInfo(folder.uri)))));
                    if (!( (addedFoldersTrustInfo.map(info => info.trusted))).every(trusted => trusted)) {
                        const { confirmed } = await this.dialogService.confirm({
                            type: Severity$1.Info,
                            message: ( localizeWithPath(_moduleId, 16, "Do you trust the authors of the files in this folder?")),
                            detail: ( localizeWithPath(
                                _moduleId,
                                17,
                                "You are adding files that are not currently trusted to a trusted workspace. Do you trust the authors of these new files?"
                            )),
                            cancelButton: ( localizeWithPath(_moduleId, 18, 'No')),
                            custom: { icon: Codicon.shield }
                        });
                        await this.workspaceTrustManagementService.setUrisTrust(( (addedFoldersTrustInfo.map(i => i.uri))), confirmed);
                    }
                }
            };
            return e.join(addWorkspaceFolder(e));
        }));
        this._register(this.workspaceTrustManagementService.onDidChangeTrust(trusted => {
            this.updateWorkbenchIndicators(trusted);
        }));
        this._register(this.workspaceTrustRequestService.onDidInitiateWorkspaceTrustRequestOnStartup(async () => {
            let titleString;
            let learnMoreString;
            let trustOption;
            let dontTrustOption;
            const isAiGeneratedWorkspace = await this.isAiGeneratedWorkspace();
            if (isAiGeneratedWorkspace && this.productService.aiGeneratedWorkspaceTrust) {
                titleString = this.productService.aiGeneratedWorkspaceTrust.title;
                learnMoreString = this.productService.aiGeneratedWorkspaceTrust.startupTrustRequestLearnMore;
                trustOption = this.productService.aiGeneratedWorkspaceTrust.trustOption;
                dontTrustOption = this.productService.aiGeneratedWorkspaceTrust.dontTrustOption;
            }
            else {
                console.warn('AI generated workspace trust dialog contents not available.');
            }
            const title = titleString ?? (this.useWorkspaceLanguage ?
                ( localizeWithPath(_moduleId, 8, "Do you trust the authors of the files in this workspace?")) :
                ( localizeWithPath(_moduleId, 9, "Do you trust the authors of the files in this folder?")));
            let checkboxText;
            const workspaceIdentifier = toWorkspaceIdentifier(this.workspaceContextService.getWorkspace());
            const isSingleFolderWorkspace = isSingleFolderWorkspaceIdentifier(workspaceIdentifier);
            const isEmptyWindow = isEmptyWorkspaceIdentifier(workspaceIdentifier);
            if (!isAiGeneratedWorkspace && this.workspaceTrustManagementService.canSetParentFolderTrust()) {
                const name = basename(dirname(workspaceIdentifier.uri));
                checkboxText = ( localizeWithPath(
                    _moduleId,
                    19,
                    "Trust the authors of all files in the parent folder '{0}'",
                    name
                ));
            }
            this.doShowModal(title, { label: trustOption ?? ( localizeWithPath(_moduleId, 20, "&&Yes, I trust the authors")), sublabel: isSingleFolderWorkspace ? ( localizeWithPath(_moduleId, 21, "Trust folder and enable all features")) : ( localizeWithPath(_moduleId, 22, "Trust workspace and enable all features")) }, { label: dontTrustOption ?? ( localizeWithPath(_moduleId, 23, "&&No, I don't trust the authors")), sublabel: isSingleFolderWorkspace ? ( localizeWithPath(_moduleId, 24, "Browse folder in restricted mode")) : ( localizeWithPath(_moduleId, 25, "Browse workspace in restricted mode")) }, [
                !isSingleFolderWorkspace ?
                    ( localizeWithPath(
                        _moduleId,
                        26,
                        "{0} provides features that may automatically execute files in this workspace.",
                        this.productService.nameShort
                    )) :
                    ( localizeWithPath(
                        _moduleId,
                        27,
                        "{0} provides features that may automatically execute files in this folder.",
                        this.productService.nameShort
                    )),
                learnMoreString ?? ( localizeWithPath(
                    _moduleId,
                    28,
                    "If you don't trust the authors of these files, we recommend to continue in restricted mode as the files may be malicious. See [our docs](https://aka.ms/vscode-workspace-trust) to learn more."
                )),
                !isEmptyWindow ?
                    `\`${this.labelService.getWorkspaceLabel(workspaceIdentifier, { verbose: 2  })}\`` : '',
            ], checkboxText);
        }));
    }
    updateWorkbenchIndicators(trusted) {
        const bannerItem = this.getBannerItem(!trusted);
        this.updateStatusbarEntry(trusted);
        if (bannerItem) {
            if (!trusted) {
                this.bannerService.show(bannerItem);
            }
            else {
                this.bannerService.hide(BANNER_RESTRICTED_MODE);
            }
        }
    }
    async doShowModal(question, trustedOption, untrustedOption, markdownStrings, trustParentString) {
        await this.dialogService.prompt({
            type: Severity$1.Info,
            message: question,
            checkbox: trustParentString ? {
                label: trustParentString
            } : undefined,
            buttons: [
                {
                    label: trustedOption.label,
                    run: async ({ checkboxChecked }) => {
                        if (checkboxChecked) {
                            await this.workspaceTrustManagementService.setParentFolderTrust(true);
                        }
                        else {
                            await this.workspaceTrustRequestService.completeWorkspaceTrustRequest(true);
                        }
                    }
                },
                {
                    label: untrustedOption.label,
                    run: () => {
                        this.updateWorkbenchIndicators(false);
                        this.workspaceTrustRequestService.cancelWorkspaceTrustRequest();
                    }
                }
            ],
            custom: {
                buttonDetails: [
                    trustedOption.sublabel,
                    untrustedOption.sublabel
                ],
                disableCloseAction: true,
                icon: Codicon.shield,
                markdownDetails: ( (markdownStrings.map(md => { return { markdown: ( (new MarkdownString(md))) }; })))
            }
        });
        this.storageService.store(STARTUP_PROMPT_SHOWN_KEY, true, 1 , 1 );
    }
    async showModalOnStart() {
        if (this.workspaceTrustManagementService.isWorkspaceTrusted()) {
            this.updateWorkbenchIndicators(true);
            return;
        }
        if (!(this.workspaceTrustManagementService.canSetWorkspaceTrust())) {
            return;
        }
        if (isVirtualWorkspace(this.workspaceContextService.getWorkspace())) {
            this.updateWorkbenchIndicators(false);
            return;
        }
        if (this.workspaceContextService.getWorkbenchState() === 1 ) {
            this.updateWorkbenchIndicators(false);
            return;
        }
        if (this.startupPromptSetting === 'never') {
            this.updateWorkbenchIndicators(false);
            return;
        }
        if (this.startupPromptSetting === 'once' && this.storageService.getBoolean(STARTUP_PROMPT_SHOWN_KEY, 1 , false)) {
            this.updateWorkbenchIndicators(false);
            return;
        }
        this.workspaceTrustRequestService.requestWorkspaceTrustOnStartup();
    }
    get startupPromptSetting() {
        return this.configurationService.getValue(WORKSPACE_TRUST_STARTUP_PROMPT);
    }
    get useWorkspaceLanguage() {
        return !isSingleFolderWorkspaceIdentifier(toWorkspaceIdentifier(this.workspaceContextService.getWorkspace()));
    }
    async isAiGeneratedWorkspace() {
        const aiGeneratedWorkspaces = URI.joinPath(this.environmentService.workspaceStorageHome, 'aiGeneratedWorkspaces.json');
        return await this.fileService.exists(aiGeneratedWorkspaces).then(async (result) => {
            if (result) {
                try {
                    const content = await this.fileService.readFile(aiGeneratedWorkspaces);
                    const workspaces = JSON.parse(( (content.value.toString())));
                    if (workspaces.indexOf(( (this.workspaceContextService.getWorkspace().folders[0].uri.toString()))) > -1) {
                        return true;
                    }
                }
                catch (e) {
                }
            }
            return false;
        });
    }
    getBannerItem(restrictedMode) {
        const dismissedRestricted = this.storageService.getBoolean(BANNER_RESTRICTED_MODE_DISMISSED_KEY, 1 , false);
        if (this.bannerSetting === 'never') {
            return undefined;
        }
        if (this.bannerSetting === 'untilDismissed' && dismissedRestricted) {
            return undefined;
        }
        const actions = [
            {
                label: ( localizeWithPath(_moduleId, 29, "Manage")),
                href: 'command:' + MANAGE_TRUST_COMMAND_ID
            },
            {
                label: ( localizeWithPath(_moduleId, 30, "Learn More")),
                href: 'https://aka.ms/vscode-workspace-trust'
            }
        ];
        return {
            id: BANNER_RESTRICTED_MODE,
            icon: shieldIcon,
            ariaLabel: this.getBannerItemAriaLabels(),
            message: this.getBannerItemMessages(),
            actions,
            onClose: () => {
                if (restrictedMode) {
                    this.storageService.store(BANNER_RESTRICTED_MODE_DISMISSED_KEY, true, 1 , 1 );
                }
            }
        };
    }
    getBannerItemAriaLabels() {
        switch (this.workspaceContextService.getWorkbenchState()) {
            case 1 :
                return ( localizeWithPath(
                    _moduleId,
                    31,
                    "Restricted Mode is intended for safe code browsing. Trust this window to enable all features. Use navigation keys to access banner actions."
                ));
            case 2 :
                return ( localizeWithPath(
                    _moduleId,
                    32,
                    "Restricted Mode is intended for safe code browsing. Trust this folder to enable all features. Use navigation keys to access banner actions."
                ));
            case 3 :
                return ( localizeWithPath(
                    _moduleId,
                    33,
                    "Restricted Mode is intended for safe code browsing. Trust this workspace to enable all features. Use navigation keys to access banner actions."
                ));
        }
    }
    getBannerItemMessages() {
        switch (this.workspaceContextService.getWorkbenchState()) {
            case 1 :
                return ( localizeWithPath(
                    _moduleId,
                    34,
                    "Restricted Mode is intended for safe code browsing. Trust this window to enable all features."
                ));
            case 2 :
                return ( localizeWithPath(
                    _moduleId,
                    35,
                    "Restricted Mode is intended for safe code browsing. Trust this folder to enable all features."
                ));
            case 3 :
                return ( localizeWithPath(
                    _moduleId,
                    36,
                    "Restricted Mode is intended for safe code browsing. Trust this workspace to enable all features."
                ));
        }
    }
    get bannerSetting() {
        const result = this.configurationService.getValue(WORKSPACE_TRUST_BANNER);
        if (result !== 'always' && isWeb && !this.remoteAgentService.getConnection()?.remoteAuthority) {
            return 'never';
        }
        return result;
    }
    getRestrictedModeStatusbarEntry() {
        let ariaLabel = '';
        let toolTip;
        switch (this.workspaceContextService.getWorkbenchState()) {
            case 1 : {
                ariaLabel = ( localizeWithPath(
                    _moduleId,
                    37,
                    "Restricted Mode: Some features are disabled because this window is not trusted."
                ));
                toolTip = {
                    value: ( localizeWithPath(
                        _moduleId,
                        38,
                        "Running in Restricted Mode\n\nSome [features are disabled]({0}) because this [window is not trusted]({1}).",
                        `command:${LIST_WORKSPACE_UNSUPPORTED_EXTENSIONS_COMMAND_ID}`,
                        `command:${MANAGE_TRUST_COMMAND_ID}`
                    )),
                    isTrusted: true,
                    supportThemeIcons: true
                };
                break;
            }
            case 2 : {
                ariaLabel = ( localizeWithPath(
                    _moduleId,
                    39,
                    "Restricted Mode: Some features are disabled because this folder is not trusted."
                ));
                toolTip = {
                    value: ( localizeWithPath(
                        _moduleId,
                        40,
                        "Running in Restricted Mode\n\nSome [features are disabled]({0}) because this [folder is not trusted]({1}).",
                        `command:${LIST_WORKSPACE_UNSUPPORTED_EXTENSIONS_COMMAND_ID}`,
                        `command:${MANAGE_TRUST_COMMAND_ID}`
                    )),
                    isTrusted: true,
                    supportThemeIcons: true
                };
                break;
            }
            case 3 : {
                ariaLabel = ( localizeWithPath(
                    _moduleId,
                    41,
                    "Restricted Mode: Some features are disabled because this workspace is not trusted."
                ));
                toolTip = {
                    value: ( localizeWithPath(
                        _moduleId,
                        42,
                        "Running in Restricted Mode\n\nSome [features are disabled]({0}) because this [workspace is not trusted]({1}).",
                        `command:${LIST_WORKSPACE_UNSUPPORTED_EXTENSIONS_COMMAND_ID}`,
                        `command:${MANAGE_TRUST_COMMAND_ID}`
                    )),
                    isTrusted: true,
                    supportThemeIcons: true
                };
                break;
            }
        }
        return {
            name: ( localizeWithPath(_moduleId, 43, "Workspace Trust")),
            text: `$(shield) ${( localizeWithPath(_moduleId, 44, "Restricted Mode"))}`,
            ariaLabel: ariaLabel,
            tooltip: toolTip,
            command: MANAGE_TRUST_COMMAND_ID,
            kind: 'prominent'
        };
    }
    updateStatusbarEntry(trusted) {
        if (trusted && this.statusbarEntryAccessor.value) {
            this.statusbarEntryAccessor.clear();
            return;
        }
        if (!trusted && !this.statusbarEntryAccessor.value) {
            const entry = this.getRestrictedModeStatusbarEntry();
            this.statusbarEntryAccessor.value = this.statusbarService.addEntry(entry, this.entryId, 0 , 0.99 * Number.MAX_VALUE );
        }
    }
};
WorkspaceTrustUXHandler = ( (__decorate([
    ( (__param(0, IDialogService))),
    ( (__param(1, IWorkspaceContextService))),
    ( (__param(2, IWorkspaceTrustEnablementService))),
    ( (__param(3, IWorkspaceTrustManagementService))),
    ( (__param(4, IConfigurationService))),
    ( (__param(5, IStatusbarService))),
    ( (__param(6, IStorageService))),
    ( (__param(7, IWorkspaceTrustRequestService))),
    ( (__param(8, IBannerService))),
    ( (__param(9, ILabelService))),
    ( (__param(10, IHostService))),
    ( (__param(11, IProductService))),
    ( (__param(12, IRemoteAgentService))),
    ( (__param(13, IEnvironmentService))),
    ( (__param(14, IFileService)))
], WorkspaceTrustUXHandler)));
registerWorkbenchContribution2(WorkspaceTrustRequestHandler.ID, WorkspaceTrustRequestHandler, 2 );
( (Registry.as(Extensions.Workbench))).registerWorkbenchContribution(WorkspaceTrustUXHandler, 3 );
class WorkspaceTrustEditorInputSerializer {
    canSerialize(editorInput) {
        return true;
    }
    serialize(input) {
        return '';
    }
    deserialize(instantiationService) {
        return instantiationService.createInstance(WorkspaceTrustEditorInput);
    }
}
( (Registry.as(EditorExtensions.EditorFactory)))
    .registerEditorSerializer(WorkspaceTrustEditorInput.ID, WorkspaceTrustEditorInputSerializer);
( (Registry.as(EditorExtensions.EditorPane))).registerEditorPane(EditorPaneDescriptor.create(WorkspaceTrustEditor, WorkspaceTrustEditor.ID, ( localizeWithPath(_moduleId, 45, "Workspace Trust Editor"))), [
    ( (new SyncDescriptor(WorkspaceTrustEditorInput)))
]);
const CONFIGURE_TRUST_COMMAND_ID = 'workbench.trust.configure';
const WORKSPACES_CATEGORY = ( localize2WithPath(_moduleId, 46, 'Workspaces'));
registerAction2(class extends Action2 {
    constructor() {
        super({
            id: CONFIGURE_TRUST_COMMAND_ID,
            title: ( localize2WithPath(_moduleId, 47, "Configure Workspace Trust Settings")),
            precondition: ( (ContextKeyExpr.and(
                WorkspaceTrustContext.IsEnabled,
                 (ContextKeyExpr.equals(`config.${WORKSPACE_TRUST_ENABLED}`, true))
            ))),
            category: WORKSPACES_CATEGORY,
            f1: true
        });
    }
    run(accessor) {
        accessor.get(IPreferencesService).openUserSettings({ jsonEditor: false, query: `@tag:${WORKSPACE_TRUST_SETTING_TAG}` });
    }
});
registerAction2(class extends Action2 {
    constructor() {
        super({
            id: MANAGE_TRUST_COMMAND_ID,
            title: ( localize2WithPath(_moduleId, 48, "Manage Workspace Trust")),
            precondition: ( (ContextKeyExpr.and(
                WorkspaceTrustContext.IsEnabled,
                 (ContextKeyExpr.equals(`config.${WORKSPACE_TRUST_ENABLED}`, true))
            ))),
            category: WORKSPACES_CATEGORY,
            f1: true,
        });
    }
    run(accessor) {
        const editorService = accessor.get(IEditorService);
        const instantiationService = accessor.get(IInstantiationService);
        const input = instantiationService.createInstance(WorkspaceTrustEditorInput);
        editorService.openEditor(input, { pinned: true });
        return;
    }
});
( (Registry.as(Extensions$1.Configuration)))
    .registerConfiguration({
    ...securityConfigurationNodeBase,
    properties: {
        [WORKSPACE_TRUST_ENABLED]: {
            type: 'boolean',
            default: true,
            description: ( localizeWithPath(
                _moduleId,
                49,
                "Controls whether or not Workspace Trust is enabled within VS Code."
            )),
            tags: [WORKSPACE_TRUST_SETTING_TAG],
            scope: 1 ,
        },
        [WORKSPACE_TRUST_STARTUP_PROMPT]: {
            type: 'string',
            default: 'once',
            description: ( localizeWithPath(
                _moduleId,
                50,
                "Controls when the startup prompt to trust a workspace is shown."
            )),
            tags: [WORKSPACE_TRUST_SETTING_TAG],
            scope: 1 ,
            enum: ['always', 'once', 'never'],
            enumDescriptions: [
                ( localizeWithPath(
                    _moduleId,
                    51,
                    "Ask for trust every time an untrusted workspace is opened."
                )),
                ( localizeWithPath(
                    _moduleId,
                    52,
                    "Ask for trust the first time an untrusted workspace is opened."
                )),
                ( localizeWithPath(
                    _moduleId,
                    53,
                    "Do not ask for trust when an untrusted workspace is opened."
                )),
            ]
        },
        [WORKSPACE_TRUST_BANNER]: {
            type: 'string',
            default: 'untilDismissed',
            description: ( localizeWithPath(_moduleId, 54, "Controls when the restricted mode banner is shown.")),
            tags: [WORKSPACE_TRUST_SETTING_TAG],
            scope: 1 ,
            enum: ['always', 'untilDismissed', 'never'],
            enumDescriptions: [
                ( localizeWithPath(
                    _moduleId,
                    55,
                    "Show the banner every time an untrusted workspace is open."
                )),
                ( localizeWithPath(
                    _moduleId,
                    56,
                    "Show the banner when an untrusted workspace is opened until dismissed."
                )),
                ( localizeWithPath(
                    _moduleId,
                    57,
                    "Do not show the banner when an untrusted workspace is open."
                )),
            ]
        },
        [WORKSPACE_TRUST_UNTRUSTED_FILES]: {
            type: 'string',
            default: 'prompt',
            markdownDescription: ( localizeWithPath(
                _moduleId,
                58,
                "Controls how to handle opening untrusted files in a trusted workspace. This setting also applies to opening files in an empty window which is trusted via `#{0}#`.",
                WORKSPACE_TRUST_EMPTY_WINDOW
            )),
            tags: [WORKSPACE_TRUST_SETTING_TAG],
            scope: 1 ,
            enum: ['prompt', 'open', 'newWindow'],
            enumDescriptions: [
                ( localizeWithPath(
                    _moduleId,
                    59,
                    "Ask how to handle untrusted files for each workspace. Once untrusted files are introduced to a trusted workspace, you will not be prompted again."
                )),
                ( localizeWithPath(
                    _moduleId,
                    60,
                    "Always allow untrusted files to be introduced to a trusted workspace without prompting."
                )),
                ( localizeWithPath(
                    _moduleId,
                    61,
                    "Always open untrusted files in a separate window in restricted mode without prompting."
                )),
            ]
        },
        [WORKSPACE_TRUST_EMPTY_WINDOW]: {
            type: 'boolean',
            default: true,
            markdownDescription: ( localizeWithPath(
                _moduleId,
                62,
                "Controls whether or not the empty window is trusted by default within VS Code. When used with `#{0}#`, you can enable the full functionality of VS Code without prompting in an empty window.",
                WORKSPACE_TRUST_UNTRUSTED_FILES
            )),
            tags: [WORKSPACE_TRUST_SETTING_TAG],
            scope: 1
        }
    }
});
let WorkspaceTrustTelemetryContribution = class WorkspaceTrustTelemetryContribution extends Disposable {
    constructor(environmentService, telemetryService, workspaceContextService, workspaceTrustEnablementService, workspaceTrustManagementService) {
        super();
        this.environmentService = environmentService;
        this.telemetryService = telemetryService;
        this.workspaceContextService = workspaceContextService;
        this.workspaceTrustEnablementService = workspaceTrustEnablementService;
        this.workspaceTrustManagementService = workspaceTrustManagementService;
        this.workspaceTrustManagementService.workspaceTrustInitialized
            .then(() => {
            this.logInitialWorkspaceTrustInfo();
            this.logWorkspaceTrust(this.workspaceTrustManagementService.isWorkspaceTrusted());
            this._register(this.workspaceTrustManagementService.onDidChangeTrust(isTrusted => this.logWorkspaceTrust(isTrusted)));
        });
    }
    logInitialWorkspaceTrustInfo() {
        if (!this.workspaceTrustEnablementService.isWorkspaceTrustEnabled()) {
            const disabledByCliFlag = this.environmentService.disableWorkspaceTrust;
            this.telemetryService.publicLog2('workspaceTrustDisabled', {
                reason: disabledByCliFlag ? 'cli' : 'setting'
            });
            return;
        }
        this.telemetryService.publicLog2('workspaceTrustFolderCounts', {
            trustedFoldersCount: this.workspaceTrustManagementService.getTrustedUris().length,
        });
    }
    async logWorkspaceTrust(isTrusted) {
        if (!this.workspaceTrustEnablementService.isWorkspaceTrustEnabled()) {
            return;
        }
        this.telemetryService.publicLog2('workspaceTrustStateChanged', {
            workspaceId: this.workspaceContextService.getWorkspace().id,
            isTrusted: isTrusted
        });
        if (isTrusted) {
            const getDepth = (folder) => {
                let resolvedPath = resolve(folder);
                let depth = 0;
                while (dirname$1(resolvedPath) !== resolvedPath && depth < 100) {
                    resolvedPath = dirname$1(resolvedPath);
                    depth++;
                }
                return depth;
            };
            for (const folder of this.workspaceContextService.getWorkspace().folders) {
                const { trusted, uri } = await this.workspaceTrustManagementService.getUriTrustInfo(folder.uri);
                if (!trusted) {
                    continue;
                }
                const workspaceFolderDepth = getDepth(folder.uri.fsPath);
                const trustedFolderDepth = getDepth(uri.fsPath);
                const delta = workspaceFolderDepth - trustedFolderDepth;
                this.telemetryService.publicLog2('workspaceFolderDepthBelowTrustedFolder', { workspaceFolderDepth, trustedFolderDepth, delta });
            }
        }
    }
};
WorkspaceTrustTelemetryContribution = ( (__decorate([
    ( (__param(0, IWorkbenchEnvironmentService))),
    ( (__param(1, ITelemetryService))),
    ( (__param(2, IWorkspaceContextService))),
    ( (__param(3, IWorkspaceTrustEnablementService))),
    ( (__param(4, IWorkspaceTrustManagementService)))
], WorkspaceTrustTelemetryContribution)));
( (Registry.as(Extensions.Workbench)))
    .registerWorkbenchContribution(WorkspaceTrustTelemetryContribution, 3 );

export { WorkspaceTrustContextKeys, WorkspaceTrustRequestHandler, WorkspaceTrustUXHandler };
